import { observable, action, runInAction } from 'mobx'
import { backendServer } from '../../variable';
import { get, post } from '../../utils/fetch';
import { errorHandler } from '../../utils/methods'

class AccountStore {
  @observable
  balance = 0; //账户余额

  /**
   * 获取账户余额
   *
   */
  @action
  getBalance = async () => {
    try {
      const response = await get(
        `${backendServer}/agentAmountOperating/queryBalance`
      );
      runInAction(() => {
        this.balance = response.data.balance;
      });
      return response;
    } catch (err) {
      return errorHandler(err, '获取账户余额');
    }
  };

  /**
   * 充值
   * amount  单位分
   * bankCode
   */
  @action
  reqRecharge = async ({ amount, bankCode }) => {
    try {
      const response = await post(
        `${backendServer}/agent/recharge/b2b/create`, { amount, bankCode }
      );
      return response;
    } catch (err) {
      return errorHandler(err, '充值');
    }
  };
};

const accountStore = new AccountStore();
export default accountStore;



// WEBPACK FOOTER //
// ./src/stores/accountStore/index.js